module.exports = __webpack_public_path__ + "static/img/color-palette-12.6339066f.svg";